import { GetterTree } from 'vuex'

import { RootState, ShopState } from '@/types/store'

export const getters: GetterTree<ShopState, RootState> = {
  shops(state): ShopState['shops'] {
    return state.shops
  },
  isShopLoading(state): ShopState['isShopsLoading'] {
    return state.isShopsLoading
  },
  shopType(state): ShopState['shopType'] {
    return state.shopType
  },
}
